import { StringSerializer_getInstance2hpyx1v3alnih as StringSerializer_getInstance } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/Primitives.mjs';
import { get_nullable197rfua9r7fsz as get_nullable } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/builtins/BuiltinSerializers.mjs';
import {
  LinkedHashMapSerializermaoj2nyji7op as LinkedHashMapSerializer,
  ArrayListSerializer7k5wnrulb3y6 as ArrayListSerializer,
} from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/CollectionSerializers.mjs';
import { LazyThreadSafetyMode_PUBLICATION_getInstance1vspt3xrdob1a as LazyThreadSafetyMode_PUBLICATION_getInstance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Lazy.mjs';
import { lazy1261dae0bgscp as lazy } from '../../../../../kotlin-kotlin-stdlib/kotlin/kotlin.mjs';
import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { PluginGeneratedSerialDescriptorqdzeg5asqhfg as PluginGeneratedSerialDescriptor } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginGeneratedSerialDescriptor.mjs';
import { Unit_instance28fytmsmm6r23 as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { UnknownFieldExceptiona60e3a6v1xqo as UnknownFieldException } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/SerializationExceptions.mjs';
import {
  typeParametersSerializers2likxjr48tr7y as typeParametersSerializers,
  GeneratedSerializer1f7t7hssdd2ws as GeneratedSerializer,
} from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginHelperInterfaces.mjs';
import {
  protoOf180f3jzyo7rfj as protoOf,
  getStringHashCode26igk1bx568vk as getStringHashCode,
  hashCodeq5arwsb9dgti as hashCode,
  equals2au1ep9vhcato as equals,
  createThis2j2avj17cvnv2 as createThis,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { toString30pk9tzaqopn as toString } from '../../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import { throwMissingFieldException2cmke0v3ynf14 as throwMissingFieldException } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginExceptions.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
function Message$Companion$$childSerializers$_anonymous__yfg1gj() {
  return new (LinkedHashMapSerializer())(StringSerializer_getInstance(), get_nullable(StringSerializer_getInstance()));
}
function Message$Companion$$childSerializers$_anonymous__yfg1gj_0() {
  return new (ArrayListSerializer())(StringSerializer_getInstance());
}
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        Companion_instance = this;
        var tmp = this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_1 = lazy(tmp_0, Message$Companion$$childSerializers$_anonymous__yfg1gj);
        var tmp_2 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp.s6q_1 = [null, null, null, tmp_1, null, null, lazy(tmp_2, Message$Companion$$childSerializers$_anonymous__yfg1gj_0)];
      }
      n29() {
        return $serializer_getInstance();
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance() {
  if (Companion_instance === VOID)
    new (Companion())();
  return Companion_instance;
}
var $serializerClass;
function $serializer() {
  if ($serializerClass === VOID) {
    class $ {
      constructor() {
        $serializer_instance = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.zegreatrob.coupling.logging.Message', this, 7);
        tmp0_serialDesc.i1z('level', false);
        tmp0_serialDesc.i1z('name', false);
        tmp0_serialDesc.i1z('message', false);
        tmp0_serialDesc.i1z('properties', false);
        tmp0_serialDesc.i1z('timestamp', false);
        tmp0_serialDesc.i1z('marker', true);
        tmp0_serialDesc.i1z('stackTrace', true);
        this.t6q_1 = tmp0_serialDesc;
      }
      u6q(encoder, value) {
        var tmp0_desc = this.t6q_1;
        var tmp1_output = encoder.o1r(tmp0_desc);
        var tmp2_cached = Companion_getInstance().s6q_1;
        tmp1_output.e1t(tmp0_desc, 0, value.v6q_1);
        tmp1_output.e1t(tmp0_desc, 1, value.w6q_1);
        tmp1_output.i1t(tmp0_desc, 2, StringSerializer_getInstance(), value.x6q_1);
        tmp1_output.i1t(tmp0_desc, 3, tmp2_cached[3].s3(), value.y6q_1);
        tmp1_output.e1t(tmp0_desc, 4, value.z6q_1);
        if (tmp1_output.m1t(tmp0_desc, 5) ? true : !(value.a6r_1 == null)) {
          tmp1_output.i1t(tmp0_desc, 5, StringSerializer_getInstance(), value.a6r_1);
        }
        if (tmp1_output.m1t(tmp0_desc, 6) ? true : !(value.b6r_1 == null)) {
          tmp1_output.i1t(tmp0_desc, 6, tmp2_cached[6].s3(), value.b6r_1);
        }
        tmp1_output.p1r(tmp0_desc);
      }
      y1m(encoder, value) {
        return this.u6q(encoder, value instanceof Message() ? value : THROW_CCE());
      }
      z1m(decoder) {
        var tmp0_desc = this.t6q_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_local2 = null;
        var tmp7_local3 = null;
        var tmp8_local4 = null;
        var tmp9_local5 = null;
        var tmp10_local6 = null;
        var tmp11_input = decoder.o1r(tmp0_desc);
        var tmp12_cached = Companion_getInstance().s6q_1;
        if (tmp11_input.e1s()) {
          tmp4_local0 = tmp11_input.y1r(tmp0_desc, 0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp11_input.y1r(tmp0_desc, 1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          tmp6_local2 = tmp11_input.c1s(tmp0_desc, 2, StringSerializer_getInstance(), tmp6_local2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
          tmp7_local3 = tmp11_input.c1s(tmp0_desc, 3, tmp12_cached[3].s3(), tmp7_local3);
          tmp3_bitMask0 = tmp3_bitMask0 | 8;
          tmp8_local4 = tmp11_input.y1r(tmp0_desc, 4);
          tmp3_bitMask0 = tmp3_bitMask0 | 16;
          tmp9_local5 = tmp11_input.c1s(tmp0_desc, 5, StringSerializer_getInstance(), tmp9_local5);
          tmp3_bitMask0 = tmp3_bitMask0 | 32;
          tmp10_local6 = tmp11_input.c1s(tmp0_desc, 6, tmp12_cached[6].s3(), tmp10_local6);
          tmp3_bitMask0 = tmp3_bitMask0 | 64;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp11_input.f1s(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp11_input.y1r(tmp0_desc, 0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp11_input.y1r(tmp0_desc, 1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              case 2:
                tmp6_local2 = tmp11_input.c1s(tmp0_desc, 2, StringSerializer_getInstance(), tmp6_local2);
                tmp3_bitMask0 = tmp3_bitMask0 | 4;
                break;
              case 3:
                tmp7_local3 = tmp11_input.c1s(tmp0_desc, 3, tmp12_cached[3].s3(), tmp7_local3);
                tmp3_bitMask0 = tmp3_bitMask0 | 8;
                break;
              case 4:
                tmp8_local4 = tmp11_input.y1r(tmp0_desc, 4);
                tmp3_bitMask0 = tmp3_bitMask0 | 16;
                break;
              case 5:
                tmp9_local5 = tmp11_input.c1s(tmp0_desc, 5, StringSerializer_getInstance(), tmp9_local5);
                tmp3_bitMask0 = tmp3_bitMask0 | 32;
                break;
              case 6:
                tmp10_local6 = tmp11_input.c1s(tmp0_desc, 6, tmp12_cached[6].s3(), tmp10_local6);
                tmp3_bitMask0 = tmp3_bitMask0 | 64;
                break;
              default:
                throw UnknownFieldException().t1o(tmp2_index);
            }
          }
        tmp11_input.p1r(tmp0_desc);
        return Message().c6r(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, null);
      }
      x1m() {
        return this.t6q_1;
      }
      y1z() {
        var tmp0_cached = Companion_getInstance().s6q_1;
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [StringSerializer_getInstance(), StringSerializer_getInstance(), get_nullable(StringSerializer_getInstance()), get_nullable(tmp0_cached[3].s3()), StringSerializer_getInstance(), get_nullable(StringSerializer_getInstance()), get_nullable(tmp0_cached[6].s3())];
      }
    }
    protoOf($).z1z = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass = $;
  }
  return $serializerClass;
}
var $serializer_instance;
function $serializer_getInstance() {
  if ($serializer_instance === VOID)
    new ($serializer())();
  return $serializer_instance;
}
var MessageClass;
function Message() {
  if (MessageClass === VOID) {
    class $ {
      constructor(level, name, message, properties, timestamp, marker, stackTrace) {
        Companion_getInstance();
        marker = marker === VOID ? null : marker;
        stackTrace = stackTrace === VOID ? null : stackTrace;
        this.v6q_1 = level;
        this.w6q_1 = name;
        this.x6q_1 = message;
        this.y6q_1 = properties;
        this.z6q_1 = timestamp;
        this.a6r_1 = marker;
        this.b6r_1 = stackTrace;
      }
      toString() {
        return 'Message(level=' + this.v6q_1 + ', name=' + this.w6q_1 + ', message=' + this.x6q_1 + ', properties=' + toString(this.y6q_1) + ', timestamp=' + this.z6q_1 + ', marker=' + this.a6r_1 + ', stackTrace=' + toString(this.b6r_1) + ')';
      }
      hashCode() {
        var result = getStringHashCode(this.v6q_1);
        result = imul(result, 31) + getStringHashCode(this.w6q_1) | 0;
        result = imul(result, 31) + (this.x6q_1 == null ? 0 : getStringHashCode(this.x6q_1)) | 0;
        result = imul(result, 31) + (this.y6q_1 == null ? 0 : hashCode(this.y6q_1)) | 0;
        result = imul(result, 31) + getStringHashCode(this.z6q_1) | 0;
        result = imul(result, 31) + (this.a6r_1 == null ? 0 : getStringHashCode(this.a6r_1)) | 0;
        result = imul(result, 31) + (this.b6r_1 == null ? 0 : hashCode(this.b6r_1)) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof Message()))
          return false;
        if (!(this.v6q_1 === other.v6q_1))
          return false;
        if (!(this.w6q_1 === other.w6q_1))
          return false;
        if (!(this.x6q_1 == other.x6q_1))
          return false;
        if (!equals(this.y6q_1, other.y6q_1))
          return false;
        if (!(this.z6q_1 === other.z6q_1))
          return false;
        if (!(this.a6r_1 == other.a6r_1))
          return false;
        if (!equals(this.b6r_1, other.b6r_1))
          return false;
        return true;
      }
      static c6r(seen0, level, name, message, properties, timestamp, marker, stackTrace, serializationConstructorMarker) {
        Companion_getInstance();
        if (!(31 === (31 & seen0))) {
          throwMissingFieldException(seen0, 31, $serializer_getInstance().t6q_1);
        }
        var $this = createThis(this);
        $this.v6q_1 = level;
        $this.w6q_1 = name;
        $this.x6q_1 = message;
        $this.y6q_1 = properties;
        $this.z6q_1 = timestamp;
        if (0 === (seen0 & 32))
          $this.a6r_1 = null;
        else
          $this.a6r_1 = marker;
        if (0 === (seen0 & 64))
          $this.b6r_1 = null;
        else
          $this.b6r_1 = stackTrace;
        return $this;
      }
    }
    initMetadataForClass($, 'Message', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance});
    MessageClass = $;
  }
  return MessageClass;
}
//region block: exports
export {
  Message as Messageyu2c6n5qdmq,
  Companion_getInstance as Companion_getInstance2dvnq0pgmsibf,
};
//endregion

//# sourceMappingURL=Message.mjs.map
